var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class OneTimeTokenSubscription {
    constructor(userInfo, gateway, requestService) {
        this.onOneTimeTokenReceived = (oneTimeToken, userId) => __awaiter(this, void 0, void 0, function* () {
            try {
                const token = yield this.gateway.getToken();
                const loggedInToken = yield this.requestService.oneTimeTokenLogin(token, oneTimeToken, userId);
                this.userInfo.jwtLogin(loggedInToken);
            }
            catch (e) {
                console.warn(e);
                this.userInfo.oneTimeTokenLoginFailed(e.message);
            }
        });
        this.userInfo = userInfo;
        this.gateway = gateway;
        this.requestService = requestService;
    }
    subscribe() {
        this.userInfo.onOneTimeTokenReceived["OneTimeTokenSubscription"] = this.onOneTimeTokenReceived;
    }
}
//# sourceMappingURL=OneTimeTokenSubscription.js.map